import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";

const EXCLUDED_ROUTES = [
  "/dashboard/calendar",
  "/dashboard/online-profile",
  "/dashboard/catalogue",
  "/dashboard/team",
  "/dashboard/settings",
  "/dashboard/customer-support",
];

const BranchMenu = ({
  data,
  styleProps,
  hoverProps,
  onChange,
  selectedBranch,
}) => {
  const { user } = useSelector((state) => state.user);
  const location = useLocation();
  const allBranchIds = useMemo(() => data.map((branch) => branch._id), [data]);
  const isExcludedRoute = EXCLUDED_ROUTES.includes(location.pathname);
  const isBookingPage = location.pathname === "/dashboard/booking";
  const isBusinessUser = user?.role === "business";

  useEffect(() => {
    if (!isBookingPage) {
      if (isExcludedRoute) {
        onChange(null, [data[0]?._id]);
      } else if (isBusinessUser) {
        onChange(null, allBranchIds);
      } else {
        onChange(null, [data[0]?._id]);
      }
    }
  }, [location.pathname]);

  const renderDisplayName = () => {
    if (selectedBranch?.length > 1) {
      return "All Branches";
    } else {
      const selectedBranchData = data.find(
        (item) => item?._id === selectedBranch[0]
      );
      return selectedBranchData?.displayName;
    }
  };

  return (
    <PopupState variant="popover" popupId="branch-menu">
      {(popupState) => (
        <>
          <Button
            variant="outlined"
            disableRipple
            startIcon={
              <img src={allIcons.homeIcon} alt="home-icon" width={20} />
            }
            endIcon={
              <KeyboardArrowDownIcon
                htmlColor={appcolors.black}
                sx={{ fontSize: "1.5rem !important" }}
              />
            }
            {...bindTrigger(popupState)}
            sx={{
              "& .MuiButton-endIcon": { borderLeft: "1px solid #ECF0F2" },
              border: "none",
              borderRadius: 0,
              padding: 0,
              display: "flex",
              justifyContent: "space-between",
              marginRight: "20px",
              color: "#0000008A",
              fontWeight: 400,
              height: "auto",
              ...styleProps,
              "&:hover": {
                color: "#0000008A",
                border: "none",
                padding: 0,
                backgroundColor: "transparent",
                ...hoverProps,
              },
            }}
          >
            {renderDisplayName()}
          </Button>
          <Menu {...bindMenu(popupState)}>
            {data.length > 0 && (
              <>
                {!isExcludedRoute && isBusinessUser && !isBookingPage && (
                  <MenuItem
                    key="all"
                    onClick={(e) => {
                      onChange(e, allBranchIds);
                      popupState.close();
                    }}
                  >
                    All Branches
                  </MenuItem>
                )}
                {data.map((item) => (
                  <MenuItem
                    key={item._id}
                    onClick={(e) => {
                      if (!isBookingPage) {
                        onChange(e, [item._id]);
                      }
                      popupState.close();
                    }}
                  >
                    {item.displayName}
                  </MenuItem>
                ))}
              </>
            )}
          </Menu>
        </>
      )}
    </PopupState>
  );
};

export default BranchMenu;
